module.exports = __webpack_public_path__ + "static/media/D08D859A-A3A2-45C7-BBF5-7085B471F6CB.5f48aa33.jpeg";